var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.582 5.51991C19.352 4.65946 18.6744 3.98171 17.8139 3.75174C16.2541 3.3338 9.99995 3.3338 9.99995 3.3338C9.99995 3.3338 3.74583 3.3338 2.1861 3.75174C1.32565 3.98171 0.647907 4.65946 0.41794 5.51991C0 7.07964 0 10.3338 0 10.3338C0 10.3338 0 13.588 0.41794 15.1477C0.647907 16.0081 1.32565 16.6859 2.1861 16.9158C3.74583 17.3339 9.99995 17.3339 9.99995 17.3339C9.99995 17.3339 16.2541 17.3339 17.8139 16.9158C18.6744 16.6859 19.352 16.0081 19.582 15.1477C20 13.588 20 10.3338 20 10.3338C20 10.3338 20 7.07964 19.582 5.51991Z",
    fill: "#ED1D24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 13.3337L13.196 10.3338L7.99997 7.33371V13.3337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.21f7822f9bb4703e247ae4cbaf106eec.svg";
export { ForwardRef as ReactComponent };